
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code4 } from "@/views/resources/documentation/element-ui/basic/link/code";

export default defineComponent({
  name: "icon",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code4
    };
  }
});
